module.exports = __webpack_public_path__ + "img/图层_1.3ddb5bd9.png";